import { formatDate } from "@/lib/formatDate"
import { Remarkable } from 'remarkable';
import { useEffect, useState } from 'react';


export default function RelatedBlogs({ blogs, related, currentSlug }) {
  const blogsortByDateCreated = blogs.sort((a, b) => new Date(b.date) - new Date(a.date));

  const blogFiltered = blogsortByDateCreated.filter(
    data => data.categories.includes(related) && data.slug !== currentSlug
  );
  const blogsFetched = blogFiltered.slice(0, 3);

  return (
    <div className="bg-white py-24 sm:py-32 font-['Inter']">
      <div className="mx-auto max-w-8xl px-4 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="medium-title">Related blog posts</h2>
          {/* <p className="mt-2 text-lg leading-8 text-gray-600">
            Learn how to grow your business with our expert advice.
          </p> */}
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-6 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {blogsFetched.map((post) => (
            <article key={post.urlPath} className="flex flex-col items-start justify-between">
              <div className="relative w-full">
                <img
                  src={`${post?.image ? post.image : "/assets/images/layout/datopian-logo-black.png"}`}
                  alt="Case Study Image"
                  className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div className="max-w-xl">
                <div className="mt-8 flex items-center gap-x-4 text-xs">
                  <time dateTime={post.date} className="text-gray-500">
                    {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </time>
                  <span className="text-gray-500">
                    {post?.readingTime ? post.readingTime + " min read" : "0 min read"}
                  </span>
                </div>
                <div className="group relative">
                  <h3 className="mt-3 text-lg font-bold text-gray-900 group-hover:text-gray-600 line-clamp-1">
                    <a href={`../${post.urlPath}`}>
                      <span className="absolute inset-0" />
                      {post.title}
                    </a>
                  </h3>
                  <p className="mt-5 line-clamp-3  body-text">{post.description}</p>
                </div>
                <div className="relative mt-8 flex items-center gap-x-2 text-start ">
                  <div className="flex -space-x-4">
                    {post.avatarUrl.map((avatar) => (
                      <img key={avatar} src={avatar} alt="Author Image" className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover object-cover" />
                    ))}
                  </div>
                  <div className="flex flex-row items-center gap-2 w-full">
                    <div className="text-sm leading-6 flex ">
                      {post.authors.length > 2 ? (
                        <div className="flex gap-1 pl-4" >
                          {post.authors.slice(0, 2).map((author, index) => (
                            <p className="font-semibold text-maingray" key={author}>
                              {author}{index !== post.authors.slice(0, 2).length - 1 ? ', ' : '...'}
                            </p>
                          ))}
                        </div>
                      ) : (
                        <div className="flex gap-1 pl-2" >
                          {post.authors.map((author, index) => (
                            <p className="font-semibold text-maingray flex flex-nowrap" key={author}>
                              {author}
                              {index !== post.authors.length - 1 && <>,&nbsp;</>}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}


